
import imgSubscribed from "~/assets/images/newsletter/img-subscribed@2x.jpg";
import imgSubscribe from "~/assets/images/newsletter/img-subscribe@2x.jpg";

export default {
	props: {
		type: {
			required: false,
			type: String,
			default: "",
		},
	},
	computed: {
		imgSrc() {
			return this.type === "subscribed" ? imgSubscribed : imgSubscribe;
		},
	},
};
